// HipaaSealImage
import { useEffect, useRef } from "react";

export default function HipaaSealImage() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (document.getElementById("hipaa-seal-container")) return;

    const htmlString = `
      <script>
        (function(d,s,i) {
          var c=d.createElement(s), g=d.getElementsByTagName(s)[0];
          c.id="hipaa-seal-container";
          c.async=true; c.src='https://app-prod.compliancygroup.com/seal.js?key='+i; 
          g.parentNode.insertBefore(c,g);
        })(document, 'script', '33fb246d-c7b1-41e4-b88f-6ed1325e2c37')
      </script>
    `;

    let newScript: any;

    if (containerRef.current) {
      containerRef.current.innerHTML = htmlString;

      // Run scripts manually
      const script = containerRef.current.getElementsByTagName("script")[0];
      newScript = document.createElement("script");
      if (script.src) {
        newScript.src = script.src;
      } else {
        newScript.text = script.innerHTML;
      }
      document.body.appendChild(newScript);
    }

    return () => {
      const script = document.getElementById("hipaa-seal-container");
      if (script) {
        script.remove();
      }
    };
  }, []);

  return <div ref={containerRef}></div>;
}
